module.exports = __webpack_public_path__ + "img/compatible-with-mausritter-88x32-dark.6da05995.png";